import { useTheme } from '@mui/material/styles';

/**
 * @returns {import('../../styles/mui/create-theme').VanSiteTheme} - The current theme
 */
const useAppTheme = () => {
  /** @type {import('../../styles/mui/create-theme').VanSiteTheme} */
  return useTheme();
};

export default useAppTheme;
